import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import PlayIcon from "@mui/icons-material/PlayArrow";
import StopIcon from "@mui/icons-material/Stop";
import { SmallSehatSpinner } from "./SehatSpinner";

interface ButtonRowProps {
  onStart: () => void;
  onStop: () => void;
  recordingInProgress: boolean;
  readyToStart: boolean;
  waitingForModel: boolean;
  pressedStop?: boolean;
  onDone?: () => void;
  enableDone?: boolean;
}
function ButtonRow({
  onStart,
  onStop,
  pressedStop,
  recordingInProgress,
  readyToStart,
  waitingForModel,
  onDone,
  enableDone,
}: ButtonRowProps) {
  console.log(
    "recordingInProgress",
    recordingInProgress,
    "pressedStop",
    pressedStop
  );
  const playButtonAppearance =
    waitingForModel && readyToStart ? (
      <SmallSehatSpinner size={26} />
    ) : (
      <>
        <PlayIcon />
      </>
    );

  return (
    <Stack direction="row" spacing="1em">
      <Button
        variant="contained"
        onClick={onStart}
        color="secondary"
        disabled={
          recordingInProgress || !readyToStart || pressedStop || waitingForModel
        }
        sx={{
          ml: "6em",
          maxWidth: "5em",
          maxHeight: "5em",
          minWidth: "5em",
          minHeight: "5em",
          fontSize: "0.5rem",
          borderRadius: "50%",
        }}
      >
        {playButtonAppearance}
      </Button>

      <Button
        sx={{
          ml: "2em",
          maxWidth: "5em",
          maxHeight: "5em",
          minWidth: "5em",
          minHeight: "5em",
          fontSize: "0.5rem",
          borderRadius: "50%",
        }}
        variant="contained"
        onClick={onStop}
        disabled={!recordingInProgress || pressedStop}
      >
        <StopIcon />
      </Button>

      {onDone && (
        <Button
          sx={{ ml: "2em" }}
          variant="contained"
          onClick={onDone}
          disabled={!enableDone}
        >
          Done
        </Button>
      )}
    </Stack>
  );
}

export default ButtonRow;
